import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../UI/Modal/Modal'
import cl from '../../UI/Modal/Modal.module.css'
import Car from "../../../assets/Icon/Car";
import Attachment from "../../../assets/Icon/Attachment";
import fnc from './Finances.module.css'
import { AppContext } from '../../../providers/appProvider';
import { baseFileURL } from '../../../Api';
import Receipt from './Receipt/Receipt';
import CompanyPriceForm from './Update/CompanyPriceForm/CompanyPriceForm';
import { useTranslation } from 'react-i18next';

const CompanyPriceModal = ({ carService, defaultCar, setDefaultCar, onSave }) => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [file, setFile] = useState(null);

    const [car, setCar] = useState(defaultCar);
    const { appState, app } = useContext(AppContext);
 
    const prices = carService.calculatePrice(defaultCar); 

    useEffect(() => {
        setCar(defaultCar)


        if(defaultCar?.dealer?.id != null && defaultCar.dealer.id > 0 ){
            setCar({
                ...defaultCar, 
                dealer_id: defaultCar.dealer.id,
            }) 
        }


    }, [defaultCar]);


    useEffect(() => {
        if (file) {
            const newForm = new FormData();
            newForm.append('car_id', defaultCar.id);
            newForm.append('invoice', file);
            carService.uploadInvoice(newForm)
                .then(response => {
                    carService.fetchCars()
                })
                .catch(error => {
                    console.error(error);
                });

        }
    }, [file]);

 

  

    const onUpdateClick = (event) => {
        carService.updateCompanyPrice(car)
        setIsModalOpen(false)
        onSave()
    };

    
 

    return (
        <div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div onClick={() => {
                    if (5 !== defaultCar.website.id) {
                        setIsModalOpen(true)
                    }
                }
                } className={fnc.financeBox + ' ' + fnc.yellFin} style={{ width: '100%'  }}>
                    <div className={fnc.financeDesc + ' nonetable '}> {t('Company')}</div>
                    <div className={fnc.financeValue}> 
                    
                        {(5 === defaultCar.website.id) ? 
                            (defaultCar.client_deposit !== 0 ? defaultCar.client_deposit : ' ')
                        : 
                            (defaultCar.total_company_price !== 0 ? defaultCar.total_company_price : ' ')
                        }
                        

                    </div>  
                </div>
                
                {/*  
                    {
                        car.company_invoice_doc && car.company_invoice_doc.length > 0 &&
                        <a className={fnc.invoiceLink} href={baseFileURL + car.company_invoice_doc} target='_blank' rel="noopener noreferrer">
                            <Attachment/>
                        </a>
                    }
                
                */}
 

                {app.hasPermission("COMPANY_INVOICE_VIEW") &&
                    <Receipt car={car} carService={carService}> </Receipt>
                }
            </div>

            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className={cl.modalHead} >
                    <h3>
                        <span className={fnc.iconHead + ' ' + fnc.yellFin} > <Car /></span>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>  
                            <div style={{ lineHeight: 1, fontSize: 14, fontWeight: 600, marginTop: 3 }}> {car.id}{defaultCar.lot !== undefined ? '/' + defaultCar.lot : '' }</div>
                        </div>
                         

                    </h3>
                </div>
                <div>
 
 
                    <CompanyPriceForm newCar={car} setNewCar={setDefaultCar} isAdd={true} prices={prices} ></CompanyPriceForm>


                    {app.hasPermission("COMPANY_PRICE_EDIT") &&
                        <div className={fnc.flexend}>
                            <button type="submit" onClick={onUpdateClick} className={fnc.btnPrimary} >შენახვა</button>
                        </div>
                    }


                </div>





            </Modal>
        </div>
    );
};

export default CompanyPriceModal;